import React from 'react';

import FriendsPromo from './friends-promo';
import NewsletterSignup from './newsletter-signup';
import PrintsPromo from './prints-promo';

import '../../../styles/common/promos/action-bar.scss'; 

const ActionBar = (props) => (
  <div role="complementary" aria-label="Additional Actions" className="action-bar">
    <div className="action-bar__headline">
      <p className="headline">
        <span className="label">If You Liked This…</span>
      </p>
    </div>
    <div className="action-bar__subscribe">
      <NewsletterSignup formLocation="action-bar" />
    </div>
    <div className="action-bar__friends">
      <FriendsPromo />
    </div>
    <div className="action-bar__prints">
      <PrintsPromo frameCount={1} />
    </div>
  </div>
);

export default ActionBar;